import SocialProfile from 'models/user/UserProfile';
import { isProductSupportMode, isRaceManagementMode, isReadonlyMode } from 'system/SystemUtil';
import { isModern } from 'utils/NavigationUtil';

let globalSocialProfileObject;

// connect-app doesn't use local storage
// keep this logic for modern users
if (
    isModern() &&
    (isReadonlyMode() || isProductSupportMode() || isRaceManagementMode()) &&
    !location.pathname.includes('delegation-authorization')
) {
    globalSocialProfileObject = new SocialProfile(JSON.parse(localStorage.getItem('viewerSocialProfile')));
} else {
    if (window.VIEWER_SOCIAL_PROFILE) {
        globalSocialProfileObject = new SocialProfile(window.VIEWER_SOCIAL_PROFILE);
        delete window.VIEWER_SOCIAL_PROFILE;
    } else {
        // This can be undefined for unathenticated user viewing a public page.  Use the default model.
        globalSocialProfileObject = new SocialProfile();
    }
}

export default globalSocialProfileObject;
